/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsSetDefaultVersionUpdateParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsSetDefaultVersionUpdateParams = zod.input<
    typeof ApiAccountsSetDefaultVersionUpdateParams
>;
export type ApiAccountsSetDefaultVersionUpdateParamsOutput = zod.output<
    typeof ApiAccountsSetDefaultVersionUpdateParams
>;
